
export default {
  name: 'PagesNavigatorHeader',
  props: {
    statistics: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      filterMenu: [],
    }
  },
  computed: {
    isAdmin() {
      return !!this.$auth?.user?.roles?.some((role) =>
        ['ADMIN', 'MODERATOR'].includes(role)
      )
    },
  },
  mounted() {
    this.$header.setVisibleAdditionalMenu(false)
    this.$header.setAdditionalMenu(null)
    this.filterMenu.push(
      {
        id: 1,
        title: 'Компании',
        path: '/navigator/companys',
        image: '/img/rec_companys.png',
        sub: () => this.statistics?.companysCount,
      },
      {
        id: 2,
        title: 'Авторы',
        path: '/navigator/authors',
        image: '/img/rec_authors.png',
        sub: () => this.statistics?.authorsCount,
      }
    )

    // if (this.isAdmin) {
    //   this.filterMenu.push({
    //     id: 5,
    //     title: 'Пользователи',
    //     path: '/navigator/users',
    //     image: '/img/rec_users.png',
    //     sub: () => this.statistics?.usersCount,
    //   })
    // }

    this.$header.setAdditionalMenu({
      logo: null,
      title: 'Навигатор',
      menu: this.filterMenu,
    })
  },
  beforeDestroy() {
    this.$header.setVisibleAdditionalMenu(false)
    this.$header.setAdditionalMenu(null)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll(_event, el) {
      if (el) {
        const { bottom } = el.getBoundingClientRect()

        if (bottom < 0) {
          this.$header.setVisibleAdditionalMenu(true)
        } else {
          this.$header.setVisibleAdditionalMenu(false)
        }
      }
    },
  },
}
